import { Injectable, OnDestroy } from '@angular/core'
import { BehaviorSubject, Subscription } from 'rxjs'
import { MbCheckoutShippingFacade } from '../facades/mb-checkout-shipping.facade'
import { tap } from 'rxjs/operators'
import { ActiveCartFacade } from '@spartacus/cart/base/root'

@Injectable({
  providedIn: 'root'
})
export class MbCheckoutShippingService implements MbCheckoutShippingFacade, OnDestroy {

  subscription: Subscription = new Subscription()

  private displaySimpleButtons = new BehaviorSubject(true)
  get isDisplaySimpleButtons () {
    return this.displaySimpleButtons.asObservable()
  }

  private addNewAddressesFormVisible = new BehaviorSubject(false)
  get isAddNewAddressesFormVisible () {
    return this.addNewAddressesFormVisible.asObservable()
  }

  constructor (protected activeCartService: ActiveCartFacade) {
    this.subscription.add(this.activeCartService.isGuestCart().pipe(
      tap(isGuestCart => {
        if (isGuestCart) {
          this.addNewAddressesFormVisible.next(true)
          this.displaySimpleButtons.next(false)
        }
      })
    ).subscribe())
  }

  ngOnDestroy (): void {
    this.subscription?.unsubscribe()
  }

  openAddNewAddressForm (): void {
    this.addNewAddressesFormVisible.next(true)
  }

  cancelAddNewAddressForm (): void {
    this.addNewAddressesFormVisible.next(false)
  }

}
